import React from 'react';
import { Container } from 'react-bootstrap';
import './Store.css';

const Store = () => {
  const address = '2nd Main Rd, Kamaraj Nagar, Azad Nagar, Choolaimedu, Chennai, Tamil Nadu 600094';
  const phone = '+91 9444363482';
  const email = 'support@freakers.com';

  return (
    <div className="store-page">
      <Container fluid className="store-container">
        <h1 className="store-title">Contact</h1>

        <div className="store-card">
          <section className="store-section">
            <h2 className="store-label">ADDRESS</h2>
            <p className="store-value">
              <span className="store-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </span>
              {address}
            </p>
          </section>

          <section className="store-section">
            <h2 className="store-label">CONTACT NUMBER</h2>
            <p className="store-value">
              <span className="store-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </span>
              <a href={`tel:${phone.replace(/\s/g, '')}`} className="store-link">{phone}</a>
            </p>
          </section>

          <section className="store-section">
            <h2 className="store-label"> MAIL</h2>
            <p className="store-value">
              <span className="store-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </span>
              <a href={`mailto:${email}`} className="store-link store-link-email">{email}</a>
            </p>
          </section>

          <section className="store-section">
            <h2 className="store-label">
              <span className="store-icon store-icon-inline" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              </span>
              OPENING HOURS
            </h2>
            <div className="store-hours">
              <p><strong>EVERY DAY</strong> 10:00 AM – 10:00 PM</p>
            </div>
          </section>

          <section className="store-section store-section-guide">
            <h2 className="store-label">VISUAL GUIDE</h2>
            <div className="store-visual-guide">
              <iframe
                title="FREAKERS store location on Google Maps"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.4989375304394!2d80.2232342!3d13.0675344!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267164ca055f9%3A0x5d7ef601a5056154!2sFREAKERS!5e0!3m2!1sen!2sin!4v1771663281956!5m2!1sen!2sin"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="store-map-iframe"
              />
              <a
                href="https://maps.app.goo.gl/xEo97Qt5Z9WvA6A59"
                target="_blank"
                rel="noopener noreferrer"
                className="store-map-link"
              >
                Open in Google Maps
              </a>
            </div>
          </section>
        </div>
      </Container>
    </div>
  );
};

export default Store;
